module.exports = __webpack_public_path__ + "img/new_logo.226445f3.png";